import { ColorsProps as _ColorsProps, Colors as _Colors } from './colors';
import _Dimens from './dimens';

export const Colors = _Colors;
export type ColorsProps = _ColorsProps
export const Dimens = _Dimens;
